import { getClientCustomFetch } from '../lib/getClientCustomFetch'
import { setData, clearData } from '../lib'

const postCart = async (address, items, { accessToken }) => {
  const customFetch = await getClientCustomFetch()
  // here in res we are merging those items quantity whose product id is same in cart
  // else if not then will directly pushing item in res
  const res = {}

  items?.forEach((item) => {
    if (res[item.id]) {
      const val = parseInt(item.q) + parseInt(res[item.id].q)
      res[item.id].q = val.toString()
    } else {
      res[item.id] = item
    }
  })
  try {
    const payload = {
      cart: {
        items: Object.values(res),
      },
      orderType: address.type,
      storeId: `${address?.storeId || address.address?.storeId || ''}`,
    }

    if (address.type === 'PICKUP') {
      payload.pickupLocationId = address.pickupLocationId
    } else if (accessToken && address.address && address.address.id) {
      payload.addressId = address.address.id
    } else {
      payload.address = address.address
    }

    // if (!accessToken) {
    //   const localItems = localCart.items || []
    //   const mergedItems = mergeItems(localItems, items)
    //   payload.cart = { items: mergedItems }
    // }
    const response = await customFetch.post('/cart', payload, {
      headers: { excludeAuth: accessToken ? false : true },
    })
    const cart = response?.data?.cart || {}
    //here we are assigning index to each cart item
    cart.items?.forEach((item, index) => {
      item.uniqueKey = `${item.id}-${index}`
      const bundleType = item?.product?.metaData?.bundleType
      if (bundleType) {
        const matchingItem = payload?.cart?.items?.find(
          (data) => data.id === item.id
        )
        const bundleItems = matchingItem?.bundleItems
        item.bundleItems = bundleItems
      }
    })
    if (!accessToken) setData('cart', JSON.stringify(cart))
    else clearData('cart')
    return cart
  } catch (err) {
    console.error(err)
    return {}
  }
}

const getCart = async (address, { accessToken }) => {
  const customFetch = await getClientCustomFetch()
  let storeId, type
  if (address?.address && typeof address?.address !== 'string') {
    storeId = address?.storeId || address.address.storeId
    type = address?.type || address.address.type
  } else {
    storeId = address.storeId
    type = address.type
  }
  const response = await customFetch.get(
    `/cart?storeId=${storeId}&orderType=${type}`,
    { headers: { excludeAuth: accessToken ? false : true } }
  )
  const { cart } = response?.data || {}
  cart?.items?.forEach((item, index) => {
    item.uniqueKey = `${item.id}-${index}`
  })
  return cart
}

export { postCart, getCart }
